import DataCoverageLine from "./DataCoverageLine";

export default DataCoverageLine;
